module.exports = __webpack_public_path__ + "static/img/icon_swipe_03.9bda90c.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_swipe_03.png
// module id = XJ5d
// module chunks = 1